import { Button, ButtonProps } from '@billy/design-system'
import React from 'react'

export const Reset = ({ children, ...rest }: ButtonProps) => (
  <Button color="danger" size="sm" type="reset" {...rest}>
    {children}
  </Button>
)
